/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import checkbox from '@salesforce/retail-react-app/app/theme/components/base/checkbox'
checkbox.baseStyle = {
    control: {
        marginTop: '0px',
        border: '1px solid',
        width: '20px',
        height: '20px',
        borderColor: 'gray.600',
        backgroundColor: 'gray.200',
        _checked: {
            background: 'gray.200',
            borderColor: 'gray.600 !important',
            svg: {
                stroke: 'purple.100 !important'
            },
            _hover: {
                borderColor: 'gray.650'
            }
        },
        _focusVisible: {
            boxShadow: 'none'
        },
        _hover: {
            background: 'gray.200 !important',
            bg: 'gray.200 !important',
            borderColor: 'gray.650'
        }
    }
}

checkbox.sizes = {
    md: {
        label: {
            fontSize: '16px',
            marginLeft: '10px',
            overflow: 'hidden',
            textTransform: 'none',
            textOverflow: 'ellipsis'
        }
    }
}

export default checkbox
